import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VerticalAlignTopOutlined } from "@ant-design/icons";
import { Layout as AntdLayout, FloatButton, Tooltip } from "antd";
import { EnvironmentTag } from "../../others/environment.js";
import { useTranslation } from "../../others/i18n.js";
const { Footer: AntdFooter } = AntdLayout;
const Footer = ({ footerHeight })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsxs(AntdFooter, {
        style: {
            height: footerHeight,
            borderTop: "1px solid #f0f0f0",
            backgroundColor: "#001529",
            color: "rgba(255, 255, 255, 0.65)",
            textAlign: "center"
        },
        children: [
            t("devowl.io GmbH (former MatthiasWeb) 2015-{{year}}", {
                year: new Date().getFullYear()
            }),
            "\xa0\xa0\xa0//\xa0\xa0\xa0",
            /*#__PURE__*/ _jsx("a", {
                href: t("https://devowl.io/privacy-policy/"),
                target: "_blank",
                rel: "noreferrer",
                children: t("Privacy Policy")
            }),
            " ",
            "\xb7",
            " ",
            /*#__PURE__*/ _jsx("a", {
                href: t("https://devowl.io/legal-notice/"),
                target: "_blank",
                rel: "noreferrer",
                children: t("Legal Notice")
            }),
            "\xa0\xa0\xa0",
            /*#__PURE__*/ _jsx(EnvironmentTag, {}),
            /*#__PURE__*/ _jsx(Tooltip, {
                title: t("Scroll to top!"),
                placement: "top",
                children: /*#__PURE__*/ _jsx(FloatButton.BackTop, {
                    target: ()=>document.getElementsByTagName("main").item(0),
                    style: {
                        bottom: "15px",
                        right: "15px"
                    },
                    children: /*#__PURE__*/ _jsx("div", {
                        style: {
                            height: 40,
                            width: 40,
                            lineHeight: "40px",
                            borderRadius: 4,
                            backgroundColor: "#1088e9",
                            color: "#fff",
                            textAlign: "center",
                            fontSize: 14
                        },
                        children: /*#__PURE__*/ _jsx(VerticalAlignTopOutlined, {
                            color: "white"
                        })
                    })
                })
            })
        ]
    });
};
export { Footer };
